// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/mutation_inactivate.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Profile_Content_Insurance_AssignedInsurance_Content_AssignedInsuranceItem(
  $id: numeric!
  $reason: String!
  $deactivated: date!
  $deactivated_by: numeric!
) {
  update_vaxiom_insurance_subscriptions_by_pk(
    _set: {
      active: false
      deactivated_reason: $reason
      deactivated: $deactivated
      deactivated_by: $deactivated_by
    }
    pk_columns: { id: $id }
  ) {
    id
  }
}

`